function editDistance(s1: any, s2: any) {
  s1 = s1.toLowerCase();
  s2 = s2.toLowerCase();

  var costs = [];
  for (var i = 0; i <= s1.length; i++) {
    var lastValue = i;
    for (var j = 0; j <= s2.length; j++) {
      if (i === 0)
        costs[j] = j;
      else {
        if (j > 0) {
          var newValue = costs[j - 1];
          if (s1.charAt(i - 1) !== s2.charAt(j - 1))
            newValue = Math.min(Math.min(newValue, lastValue),
              costs[j]) + 1;
          costs[j - 1] = lastValue;
          lastValue = newValue;
        }
      }
    }
    if (i > 0)
      costs[s2.length] = lastValue;
  }

  return costs[s2.length];
}


export const similarity = (s1: any, s2: any) => {
  var longer = s1;
  var shorter = s2;

  if (s1.length < s2.length) {
    longer = s2;
    shorter = s1;
  }

  var longerLength = longer.length;

  if (longerLength === 0) {
    return 1.0;
  }

  return (longerLength - editDistance(longer, shorter)) / parseFloat(longerLength);
}

export const normalize = (s1: any, excecao: string | null = null) => {

  if (excecao) {
    return s1.normalize('NFD').replace(excecao, "").replace(/[\u0300-\u036f]/g, "").replace(/[^\w\s]/gi, '')
  }

  return s1.normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(/[^\w\s]/gi, '');
}

export const somenteDigitos = (valor?: string | null): string => (valor ?? '').replace(/\D/g, '');

export const formatarCnpj = (valor?: string | null): string => {
  const digitos = somenteDigitos(valor).slice(0, 14);
  if (digitos.length !== 14) return valor ?? '';
  return digitos.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
}